import Vue from "vue"
import urljoin from 'url-join'

let instance

const BASE_URL = process.env.VUE_APP_API_BASE_URL // 'http://192.168.1.200:3012/api'

const GET = 'GET'
const PUT = 'PUT'
const POST = 'POST'
const DELETE = 'DELETE'

const crawlPath = path => {
  path = Array.isArray(path) ? path : [path]
  return path.map(item => item.toString())
}

const resolve = (path, query = {}) => {
  const queryStr = Object.keys(query).length > 0 
    ? '?' + Object.entries(query).map(queryArr => `${queryArr[0]}=${queryArr[1]}`).join('&')
    : ''
  
  const pathArr = crawlPath(path)
  // const url = urljoin(BASE_URL, ...pathArr, queryStr)
  const url = urljoin(...pathArr, queryStr)
  return url
}

const fullpath = (path) => {
  return urljoin(BASE_URL, path)
}

const stringify = (input) => {
  if (input === undefined || input === null) {
    return ''
  } else if (typeof input === 'string' || input instanceof String) {
    return input
  } else {
    return JSON.stringify(input)
  }
}

const fetchWithAuth = (auth, path, method = GET, body = undefined, opts = {}) => {
  opts.method = method

  return new Promise((resolve, reject) => {
    auth.getTokenSilently()
      .then(token => {

        opts.headers = Object.assign({}, opts.headers || {}, {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`    // send the access token through the 'Authorization' header
        })

        if (body) opts.body = stringify(body)

        resolve(fetch(fullpath(path), opts))
      })
      .catch(err => reject(err))
  })
}

const plugin = (options) => {
  console.log('api plugin', options)
  if (instance) return instance;

  // The 'instance' is simply a Vue object
  instance = new Vue({
    methods: {
      get(path, opts = {}) {
        return fetchWithAuth(this.$auth, path, GET, undefined, opts)
      },
      post(path, body, opts = {}) {
        return fetchWithAuth(this.$auth, path, POST, body, opts)
      },
      put(path, body, opts = {}) {
        return fetchWithAuth(this.$auth, path, PUT, body, opts)
      },
      delete(path, body = undefined, opts = {}) {
        return fetchWithAuth(this.$auth, path, DELETE, body, opts)
      },
      
      resolvePath(path, query) {
        return resolve(path, query)
      },
    },
  })
  
  return instance
}

export default {
  install(Vue, options) {
    Vue.prototype.$api = plugin(options);
  }
}